"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNotificationListFilters = exports.getStartEndFromDuration = void 0;
const tslib_1 = require("tslib");
const moment_1 = tslib_1.__importDefault(require("moment"));
const react_1 = require("react");
const useURLSearchParams_1 = require("../../../hooks/useURLSearchParams");
const getStartEndFromDuration = (duration, startDate, endDate) => {
    if (duration === 'custom_duration') {
        return {
            startDate: startDate || null,
            endDate: endDate || null,
        };
    }
    if (duration === 'last_24_hours') {
        return {
            startDate: moment_1.default.utc().subtract(24, 'hour').format('YYYY-MM-DD'),
            endDate: moment_1.default.utc().format('YYYY-MM-DD'),
        };
    }
    if (duration === 'last_7_days') {
        return {
            startDate: moment_1.default.utc().subtract(7, 'day').format('YYYY-MM-DD'),
            endDate: moment_1.default.utc().format('YYYY-MM-DD'),
        };
    }
    return { startDate: null, endDate: null };
};
exports.getStartEndFromDuration = getStartEndFromDuration;
const useNotificationListFilters = () => {
    const { getURLParamValue, updateURLParamValue } = (0, useURLSearchParams_1.useURLSearchParams)();
    const [typeFilter, setTypeFilter] = (0, react_1.useState)(getURLParamValue('type'));
    const [statusFilter, setStatusFilter] = (0, react_1.useState)(getURLParamValue('status'));
    const [durationFilter, setDurationFilter] = (0, react_1.useState)(getURLParamValue('duration')[0] || null);
    const [startDateFilter, setStartDateFilter] = (0, react_1.useState)(getURLParamValue('startDate')[0] || null);
    const [endDateFilter, setEndDateFilter] = (0, react_1.useState)(getURLParamValue('endDate')[0] || null);
    const [sortBy, setSortBy] = (0, react_1.useState)(getURLParamValue('sortBy')[0] || null);
    const applyFilters = (filters) => {
        setTypeFilter(filters.type);
        setStatusFilter(filters.status);
        const dates = (0, exports.getStartEndFromDuration)(filters.duration, filters.startDate, filters.endDate);
        setStartDateFilter(dates.startDate);
        setEndDateFilter(dates.endDate);
        setDurationFilter(filters.duration || null);
    };
    const resetFilters = () => {
        setTypeFilter([]);
        setStatusFilter([]);
        setStartDateFilter(null);
        setEndDateFilter(null);
        setDurationFilter(null);
    };
    (0, react_1.useEffect)(() => {
        updateURLParamValue('status', statusFilter);
    }, [statusFilter]);
    (0, react_1.useEffect)(() => {
        updateURLParamValue('type', typeFilter);
    }, [typeFilter]);
    (0, react_1.useEffect)(() => {
        updateURLParamValue('duration', durationFilter);
    }, [durationFilter]);
    (0, react_1.useEffect)(() => {
        updateURLParamValue('startDate', startDateFilter);
    }, [startDateFilter]);
    (0, react_1.useEffect)(() => {
        updateURLParamValue('endDate', endDateFilter);
    }, [endDateFilter]);
    (0, react_1.useEffect)(() => {
        updateURLParamValue('sortBy', sortBy);
    }, [sortBy]);
    return {
        typeFilter,
        setTypeFilter,
        statusFilter,
        setStatusFilter,
        durationFilter,
        setDurationFilter,
        startDateFilter,
        setStartDateFilter,
        endDateFilter,
        setEndDateFilter,
        sortBy,
        setSortBy,
        applyFilters,
        resetFilters,
        isFiltersApplied: !!typeFilter.length ||
            !!statusFilter.length ||
            durationFilter !== null ||
            startDateFilter !== null ||
            endDateFilter !== null,
    };
};
exports.useNotificationListFilters = useNotificationListFilters;
//# sourceMappingURL=useNotificationListFilters.js.map